import moment from "moment";
import { ECategoryPredictive } from "../hooks/usePredictives";

export const convertToDate = (date?: string | number | Date) => {
  if (!date) return;
  return moment(date).format(moment.localeData().longDateFormat("L"));
};

export function convertToDateAndHour(date?: string) {
  if (!date) return;
  return moment(date).format(
    `${moment.localeData().longDateFormat("L")} - HH:mm`
  );
}

export function convertToHourAndDate(date?: string) {
  if (!date) return;
  return moment(date).format(
    `HH:mm - ${moment.localeData().longDateFormat("L")}`
  );
}
export const convertDayWeek = (dates: string | number | Date) => {
  return moment(dates).format("dddd");
};

export const addDaysToDate = (date: string | number | Date, days: number) => {
  if (!date) return;
  return moment(date).add(days, "days").format("DD/MM/YYYY");
};

export function startDateToApiString(
  date?: Date | string | null
): string | undefined {
  if (!date) return;
  return moment(date).startOf("day").format();
}

export function endDateToApiString(
  date?: Date | string | null
): string | undefined {
  if (!date) return;
  return moment(date).endOf("day").format();
}

export const convertYearMonthyWeek = (date?: string | number | Date) => {
  if (!date) return "";
  return moment(date).format("YYYY/MM/DD");
};

export function countdownDate(userCreatedAt: Date | string) {
  // const createdMoment = userCreatedAt
  //   ? moment(userCreatedAt).startOf("day")
  //   : moment("2025-01-01T00:00:00.113Z").startOf("day");
  const createdMoment = moment(userCreatedAt).startOf("day");

  if (!createdMoment.isValid()) return 0;
  const today = moment().startOf("day");
  const diff = today.diff(createdMoment, "days");
  // Se a data de criação for no futuro, retorna 0
  return diff >= 0 ? diff : 0;
}

export const meetingDate = ({
  category,
  date,
  t,
}: {
  category: string;
  date: string;
  t?: (key: string) => string;
}): string => {
  if (category === ECategoryPredictive.copom) {
    if (!date) return "";

    const expirationDate = moment.utc(date);
    const dayBefore = moment.utc(expirationDate).subtract(1, "day");

    // Formata o dia anterior (sem zero à esquerda)
    const dayBeforeFormatted = dayBefore.format("D");

    // Formata o dia da expiração (sem zero à esquerda)
    const day = expirationDate.format("D");

    // Formata o mês usando o locale do moment (já configurado pelo LanguageProvider)
    // O locale do moment já está configurado baseado no idioma do i18n
    // O format("MMM") retorna a abreviação do mês no idioma correto
    const month = expirationDate.format("MMM");

    // Formata o ano
    const year = expirationDate.format("YYYY");

    // Formata como "9 - 10 dez. 2025" (adiciona ponto após o mês)
    const dateRange = `${dayBeforeFormatted} - ${day} ${month}. ${year}`;

    // Usa a tradução se disponível, caso contrário usa "Reunião" como fallback
    const meetingLabel = t ? t("global.predictives.meeting") : "Reunião";

    return `${meetingLabel} ${dateRange}`;
  }
  return "";
};

export const meetingDateFormatted = ({
  category,
  date,
}: {
  category: string;
  date: string;
}): { title: string; dateRange: string } => {
  if (category === ECategoryPredictive.copom) {
    if (!date) return { title: "", dateRange: "" };
    const expirationDate = moment.utc(date);
    const dayBefore = moment.utc(date).subtract(1, "day");
    const dayBeforeFormatted = dayBefore.format("DD");
    const day = expirationDate.format("DD");
    const monthRaw = expirationDate.locale("pt-br").format("MMM");
    const month = monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1);
    const year = expirationDate.format("YYYY");

    return {
      title: "Reunião do Copom",
      dateRange: `${dayBeforeFormatted}-${day} ${month}. ${year}`,
    };
  }
  return { title: "", dateRange: "" };
};

export const parseExpireDate = (expireDate: string | undefined) => {
  if (!expireDate) return { date: null, hour: 12, minute: 0 };

  // Aceita formato ISO (da API) ou formato local
  const m = moment(expireDate);
  if (!m.isValid()) return { date: null, hour: 12, minute: 0 };

  return { date: m.toDate(), hour: m.hour(), minute: m.minute() };
};

export const formatUtcDateOnly = (date: Date | null): string => {
  if (!date) return "--/--/----";
  return moment.utc(date).format(moment.localeData().longDateFormat("L"));
};

export const formatTimeOnly = (hour: number, minute: number): string => {
  return moment().hour(hour).minute(minute).format("HH:mm");
};
